import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { PromoBanner } from "@/components/site/PromoBanner";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { MenuSection } from "@/components/site/MenuSection";
import { EventsSection } from "@/components/site/EventsSection";
import { Gallery } from "@/components/site/Gallery";
import { Footer } from "@/components/site/Footer";

export default function HomePage() {
  const [content, setContent] = useState(null);
  const [promoOpen, setPromoOpen] = useState(true);

  useEffect(() => {
    api.get("/content").then(({ data }) => setContent(data)).catch(() => {});
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dough">
        <div className="w-10 h-10 rounded-full border-2 border-ink/20 border-t-terracotta animate-spin" />
      </div>
    );
  }

  const { settings, menu, gallery } = content;
  const promoVisible = promoOpen && settings?.promo_enabled;

  return (
    <SmoothScroll>
      <div className="bg-dough" data-testid="home-page">
        <PromoBanner settings={settings} onToggle={setPromoOpen} />
        <Header settings={settings} promoVisible={promoVisible} />
        <Hero settings={settings} />
        <Marquee />
        <Manifesto settings={settings} />
        <MenuSection menu={menu} />
        <EventsSection settings={settings} />
        <Gallery gallery={gallery} />
        <Footer settings={settings} />
      </div>
    </SmoothScroll>
  );
}
